export * from './FeatureConstants';

export const US_REGION_ID = 102001;
